/** Thrown when login fails because the user's email is not yet confirmed. */
export class EmailNotConfirmedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EmailNotConfirmedError";
  }
}

export class EmailAlreadyExistsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EmailAlreadyExistsError";
  }
}

export class CaptchaVerificationRequiredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CaptchaVerificationRequiredError";
  }
}

export class CaptchaVerificationFailedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CaptchaVerificationFailedError";
  }
}
